import { FolkReorderableAttribute } from '../folk-reorderable-attribute';
FolkReorderableAttribute.define();
//# sourceMappingURL=folk-reorderable.js.map